import { mapState } from "vuex";

import portletComponent from "@/components/child/containers/portlet.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import multiSelectComponent from "@/components/child/multiSelect/multiSelect.vue";
import { Component } from "@/decorators";
import DashboardModel from "@/models/dashboard/dashboardModel";
import UsuarioModel from "@/models/usuarioModel";
import franquiaService from "@/services/franquiaService";
import tipoVendaService from "@/services/tipoVendaService";
import { AppState, SessionActions } from "@/store/store";

import DashboardComponent from "./dashboardComponent";
import periodoFiltroComponent from "./filtros/periodoFiltroComponent.vue";

// Precisa ser assim se não ocorre erro
// eslint-disable-next-line @typescript-eslint/no-var-requires
const echarts = require("echarts");

@Component({
    components: {
        portletComponent,
        checkboxComponent,
        dateTimePickerComponent,
        multiSelectComponent,
        comboComponent,
        periodoFiltroComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: unknown) => (state as AppState).session.usuarioLogado,
        }),
    },
})
export default class TotaisPorCategoria extends DashboardComponent {
    // State computed props
    usuarioLogado!: UsuarioModel;

    private graficoVendasVendedorMensal: any;
    private graficoPercVendasPrescritorMensal: any;
    private graficoPercOrigemAtendimento: any;
    private graficoVendasVisitadorMensal: any;

    franquiaIds: Array<Object | undefined> = [];
    defaultFranquia: Array<Object | undefined> = [];
    franquiasOptions: Array<Object | undefined> = [];
    tipoVendaOptions: Array<Object | undefined> = [];
    taxaEntrega = true;
    tipoVenda = 0;

    private graphStyle = {
        width: "100%",
        height: "500px",
        margin: "25px 0px 0px 0px",
        // @ts-ignore
        zoom: this.compensarZoomGrafico(document.body.style.zoom),
    };

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        this.tipoVendaOptions = await tipoVendaService.comboCached(this.usuarioLogado.franquiaId!);

        await this.loadFranquias().withLoading();
        this.defaultFranquia.push(this.franquiasOptions.find((p: any) => p["value"] === this.usuarioLogado.franquiaId));
    }

    private loadReferences() {
        this.graficoVendasVendedorMensal = echarts.init(this.$refs.vendasVendedorAnual);
        this.graficoPercVendasPrescritorMensal = echarts.init(this.$refs.percVendasPrescritorMensal);
        this.graficoPercOrigemAtendimento = echarts.init(this.$refs.percOrigemVendas);
        this.graficoVendasVisitadorMensal = echarts.init(this.$refs.vendasVisitador);

        this.setGraficos([
            this.graficoVendasVendedorMensal,
            this.graficoPercVendasPrescritorMensal,
            this.graficoPercOrigemAtendimento,
            this.graficoVendasVisitadorMensal,
        ]);
    }

    private async onUpdateDashboard(dataInicial: Date, dataFinal: Date) {
        this.loadReferences();
        this.showLoadingGraficos();

        const data = await this.service
            .getTotaisPorCategoria(
                this.franquiaIds.map((p: any) => p["value"]),
                dataInicial,
                dataFinal,
                this.taxaEntrega,
                this.tipoVenda,
            )
            .withLoading()
            .resolveWithJSON<{
                informacoes: Record<string, DashboardModel[]>;
            }>();

        this.graficoVendasVendedorMensal.setOption(
            this.getOpcoesGrafico({
                titulo: this.$t("__.ts.vendasVendedorAnual") as string,
                labels: data.informacoes["VendasVendedor"].map((d: any) => this.getMonthName(d.label)),
                dados: data.informacoes["VendasVendedor"],
                tipoGrafico: "line",
                format: "<b>{b}</b><br/>{a}<br/>R$ {c}",
                multiSerie: true,
                mostrarLegenda: true,
            }),
        );

        this.graficoPercVendasPrescritorMensal.setOption(
            this.getOpcoesGraficoPie(
                this.$t("__.ts.percVendasPrescritorMensal") as string,
                data.informacoes["PercManipulacoesPrescritorMensal"],
            ),
        );

        this.graficoPercOrigemAtendimento.setOption(
            this.getOpcoesGraficoPie(
                this.$t("__.ts.percOrigemVendas") as string,
                data.informacoes["OrigemAtendimento"],
            ),
        );

        this.graficoVendasVisitadorMensal.setOption(
            this.getOpcoesGrafico({
                titulo: this.$t("__.ts.vendasVisitador") as string,
                labels: data.informacoes["VendasVisitador"].map((d: any) => this.getMonthName(d.label)),
                dados: data.informacoes["VendasVisitador"],
                tipoGrafico: "line",
                format: "<b>{b}</b><br/>{a}<br/>R$ {c}",
                multiSerie: true,
                mostrarLegenda: true,
            }),
        );

        this.hideLoadingGraficos();
    }

    protected convertToString(numero: number) {
        return numero == null ? "0" : numero.toString();
    }

    private async loadFranquias() {
        const data = await franquiaService.comboCached(this.usuarioLogado.franquiaId!);
        this.franquiasOptions = data.map(franquia => ({
            value: franquia.id,
            text: franquia.nomeFantasia,
        }));
    }

    private onSelecionarTodas() {
        this.franquiaIds = this.franquiasOptions;
        this.defaultFranquia = this.franquiasOptions;
    }

    private onLimpar() {
        this.franquiaIds = [];
        this.defaultFranquia = [];
    }
}
